module.exports = __webpack_public_path__ + "img/grandres_electrodomesticos.9367010a.png";